import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FullSpinnerService } from '../../../services/full-spinner.service';
import { Router } from '@angular/router';
import { REPORT_TEMPLATE_SEARCH_CRITERIA_KEY, ReportTemplateSearchCriteria } from '../../../models/searchCriteria/ReportTemplateSearchCriteria';
import { ReportTemplate } from '../../../models/ReportTemplate';
import { ReportTemplateService } from '../../../services/report-template.service';
import { AppConstants } from '../../../utils/AppConstants';
import { BaseSearchCriteria } from '../../../models/searchCriteria/BaseSearchCriteria';
import { TooltipDirective } from '../../../utils/tooltip.directive';
import { HasPermissionDirective } from '../../../utils/has-permission.directive';
import { ConfirmAlertComponent } from '../../shared/confirm-alert/confirm-alert.component';
import { ThOrderingComponent } from '../../shared/th-ordering/th-ordering.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { AppEnums } from '../../../models/AppEnums';
import { FilterPanelComponent } from '../../shared/filter-panel/filter-panel.component';
import { AlertService } from '../../shared/alert/alert.service';
import { StorageService } from '../../../services/storage.service';

@Component({
  selector: 'app-report-template-list',
  standalone: true,
  imports: [
    CommonModule,
    NgxPaginationModule,
    ThOrderingComponent,
    ConfirmAlertComponent,
    HasPermissionDirective,
    FilterPanelComponent,
    FormsModule,
    ReactiveFormsModule,
    TooltipDirective],
  templateUrl: './report-template-list.component.html',
  styleUrl: './report-template-list.component.scss'
})
export class ReportTemplateListComponent implements OnInit {

  searchForm!: FormGroup;
  emptySearchCriteria: ReportTemplateSearchCriteria = { name: undefined, pageSize: AppConstants.pageSize, pageNumber: 1, orderBy: 'type', descOrder: false };
  searchCriteria: ReportTemplateSearchCriteria = { ...this.emptySearchCriteria };

  reportTemplates: ReportTemplate[] = [];

  selectedReportTemplate?: ReportTemplate;
  totalItems: number = 0;

  showConfirmationModal: boolean = false;
  confirmationMessage: string = '';
  confirmOperationType: 'DEL' | undefined = undefined;

  constructor(
    private reportTemplateService: ReportTemplateService,
    private alertService: AlertService,
    private storageService: StorageService,
    private fullSpinnerService: FullSpinnerService,
    private fb: FormBuilder,
    private router: Router) {
    this.searchForm = this.fb.group({
      name: [undefined],
    });
    this.clearFilter();
    fullSpinnerService.spinner(undefined);

  }
  ngOnInit(): void {
    this.fullSpinnerService.spinner(undefined);
    if (AppConstants.storeNavigationInfo) {
      let scObj = this.storageService.retrieveNavigationInfo(REPORT_TEMPLATE_SEARCH_CRITERIA_KEY);
      if (scObj !== null) {
        this.searchCriteria = scObj;
      }
      else
        this.storageService.saveNavigationInfo(this.searchCriteria, REPORT_TEMPLATE_SEARCH_CRITERIA_KEY);
    }
    this.searchForm.patchValue(this.searchCriteria);
    this.find();
  }



  edit(id?: number, templateVersion?: number) {
    this.router.navigate([(templateVersion === 2 ? 'report-template-v2/' : 'report-template/') + id]);
  }


  find() {
    this.fullSpinnerService.spinner('');
    this.storageService.saveNavigationInfo(this.searchCriteria, REPORT_TEMPLATE_SEARCH_CRITERIA_KEY);
    this.reportTemplateService.find(this.searchCriteria).subscribe({
      next: (res) => {
        this.reportTemplates = res.items;
        this.totalItems = res.totalItems;
      }, complete: () => {
        this.fullSpinnerService.spinner(undefined);
      }
      , error: () => {
        this.fullSpinnerService.spinner(undefined);
      }
    });
  }

  computeNameReport(id: string) {
    return AppEnums.reportTemplateTypes.find(type => type.id === id)?.description
  }

  search(): void {
    this.searchCriteria = {
      ...this.searchCriteria,
      ...this.searchForm.value
    }
    this.find();
  }

  clearFilter(withSearch: boolean = false) {
    this.searchCriteria = { ...this.emptySearchCriteria };
    this.searchForm.patchValue(this.searchCriteria);
    if (withSearch)
      this.find();
  }


  pageChanged(event: number) {
    this.searchCriteria.pageNumber = event;
    this.find();
  }

  ordering(baseSearchCriteria: BaseSearchCriteria | undefined) {
    this.searchCriteria = baseSearchCriteria as ReportTemplateSearchCriteria
    this.find();
  }


  confirmOperation(reportTemplate: ReportTemplate, confirmOperationType: "DEL" | undefined) {
    this.showConfirmationModal = true;
    this.confirmOperationType = confirmOperationType;
    if (confirmOperationType === 'DEL') {
      this.confirmationMessage = "Eliminazione template - Sicuro di voler eliminare il template " + reportTemplate.name;
    }
    this.selectedReportTemplate = reportTemplate;
  }


  cancelModalOperationExec() {
    this.selectedReportTemplate = undefined;
    this.showConfirmationModal = false;
  }

  modalOperationExec() {
    this.fullSpinnerService.spinner('');
    if (this.confirmOperationType === 'DEL') {
      this.reportTemplateService.delete(this.selectedReportTemplate!.id!).subscribe({
        next: (res) => {
          this.alertService.addErrors(AppConstants.titleDeleteSuccessMessage, [AppConstants.successMessage], true);
          this.cancelModalOperationExec();
          this.fullSpinnerService.spinner(undefined);
          this.find()
        }, complete: () => {

        }
        , error: () => {
          this.cancelModalOperationExec();
          this.alertService.addErrors(AppConstants.titleErrorMessage, [AppConstants.errorMessage], true);
          this.fullSpinnerService.spinner(undefined);
        }
      });
    }
  }
}

